import { render } from "./CookieTimer.vue?vue&type=template&id=1fbb4d6e"
import script from "./CookieTimer.vue?vue&type=script&lang=js"
export * from "./CookieTimer.vue?vue&type=script&lang=js"

import "./CookieTimer.vue?vue&type=style&index=0&id=1fbb4d6e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__